import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { productsSlice, productsState } from './PricingSlice';

import { sortDirectionType, price } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';

import ShowMaterial from '../Materials/ShowModal/ShowModal';
import ShowService from '../Services/ShowModal/ShowModal';
import { Confirm } from '../../components/Alerts/Alerts';
import ShowProduct from './ShowModal/ShowModal';

import { havePermission } from '../../services/hoc/permissions';
import AddPrice from './AddPrice/AddPrice';
import { addPriceSlice } from './AddPrice/AddPriceSlice';
import { Col, Row } from 'react-grid-system';
import { editPricingSlice } from './EditPricing/EditPricingSlice';
import EditPricing from './EditPricing/EditPricing';
import { Tooltip } from '@mui/material';
import EditALlTable from '../../components/EditAllTable/EditAllTable';
import {  useFormik } from 'formik';
import * as Yup from 'yup';
import { getListSort } from '../../services/hoc/sort';
import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';
import { AxiosError } from 'axios';

import { useAPI } from '../../services/hoc/useAPI';
export default () => {
  // Translation
  const t = useTranslation();
  const formik = useFormik<price[]>({
    initialValues: [],
    validationSchema: Yup.array().of(
      Yup.object().shape({
        price: Yup.number().min(0),
      }),
    ),
    onSubmit: () => { },
  });
  const [modal, setModal] = useState({
    openShowService: false,
    openAddPrice: false,
    openEditPricing: false,
    openShowProduct: false,
    openShowMaterial: false,
  });
  const [openEditALlTable, setOpenEditAllTable] = useState(false);

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { products: productsState }) => state.products,
  );
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });

  const [isFetching, setIsFetching] = useState(false)
  // Hooks
  const keyword_ref = useRef<string|null>(null)

const ENDPOINTS = useAPI()

  // Search
  const search = (value: string) => {
    dispatch(productsSlice.actions.reset());
    keyword_ref.current= Boolean(value)?value:null
    fetchData(1, Boolean(value) ? 20 : 8, value);
  };

  // Fetch Data
  const fetchData =useCallback( (
      page: number,
      page_size: number = 8, 
      keyword?: string
    , sort_direction?:sortDirectionType
    , sort_field?:number
) => {
    dispatch(productsSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    setIsFetching(true)
    ENDPOINTS.pricing()
      .index({
        page,
        page_size,
        keyword,
        sort_direction,
        sort_field,
      })
      .then((response: any) => {
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        dispatch(
          productsSlice.actions.initializePrices(response.data.data.pricing),
        );

        dispatch(
          productsSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );
        setIsFetching(false)
        dispatch(productsSlice.actions.setIsFetching(false));
        if (!state.isLoaded) dispatch(productsSlice.actions.setIsLoaded(true));
      }).catch((err: AxiosError) => {
        alertError500(err)
        dispatch(productsSlice.actions.setIsFetching(false));
        setIsFetching(false)
      })
  },[state.isLoaded,dispatch,ENDPOINTS])

  const fetchSortedData =useCallback ((
    sort_field: number,
    sort_direction: sortDirectionType,
  ) => {
    if (sort_direction && sort_field) {
      fetchData(state.page,8,'',sort_direction,sort_field)
    }
  },[state.page])



  const actions = (price: price) => (
    <div className="show-on-hover">
      {havePermission('Show Product')
        ? ''
        : // <i
        //   className="icon-info"
        //   onClick={(e: React.MouseEvent<HTMLLIElement>) => {
        //     e.stopPropagation();
        //     dispatch(productsSlice.actions.setPrice(price));
        //     dispatch(productsSlice.actions.setShowPrice(true));
        //     // dispatch(showProductSlice.actions.setIsOpen({ id: price.pid, isOpen: true }))
        //   }}
        // />
        ''}
      {havePermission('Edit Pricing') ? (
        <Tooltip title={t('edit')}>
          <i
            className="icon-edit"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              dispatch(editPricingSlice.actions.setIsOpen(true));
              setModal((pre) => ({ ...pre, openEditPricing: true }));
              dispatch(
                editPricingSlice.actions.set({
                  id: price.id,
                  glass_id: price.glasses.id??-1,
                  glass_work_id: price.glass_work_id,
                  price: `${price.price}`,
                }),
              );
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Delete Pricing') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(price.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );
  const rows = () => {
    return state.prices[state.page]
      ? state.prices[state.page].map((price, index) => {
        return (
          <RowContainer
            columns={[
              price.glasses?.name,
              price.glasses?.code,
              price.glassworks?.name,
              price.glassworks?.code,
              price.price,
              actions(price),
            ]}
            item_id={price.id.toString()}
            state_length={state.prices[state.page].length}
            tr_index={index}
            onSelect={toggleSelectedId}
          />
        );
      })
      : null;
  };
  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Product')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };
  const upadtePrices = (): boolean => {
    let is_succeed = true;
    if (!formik.isValid) {
      return (is_succeed = false);
    }
    dispatch(editPricingSlice.actions.setIsLoading(true));
    ENDPOINTS.pricing()
      .updateGlassPrices({ prices: formik.values })
      .then((response: any) => {
        let new_prices: price[] = [];

        state.prices[state.page].map((elem) => {
          let new_price = response.data.data.filter(
            (ele: any) => elem.id === ele.pid,
          )[0];
          if (new_price) {
            new_prices.push({ ...elem, price: new_price.price });
          }
        });

        if (new_prices.length > 0) {
          dispatch(productsSlice.actions.initializePrices(new_prices));
        }
      })
      .catch((err: any) => {
        is_succeed = false;
      });
    return is_succeed;
  };
  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);

    dispatch(productsSlice.actions.setIsLoading(true));
    ENDPOINTS.pricing()
      .deletePrices({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(productsSlice.actions.setIsLoading(false));

        dispatch(productsSlice.actions.deleteprices(ids));
      })
      .catch((error: any) => {
        dispatch(productsSlice.actions.setIsLoading(false));
        alertError500(error);
      });
  };
  const customHandleChange = (e: React.ChangeEvent<Element>) => {
    formik.handleChange(e);
  };

  // First fetch
  useEffect(() => {
    if (!isFetching && !state.isLoaded) fetchData(1);
  }, []);

  useEffect(() => {
    if (!isFetching && !state.showPrice) {
      if (
        state.prices &&
        state.prices[state.page] &&
        state.prices[state.page].length > 0
      ) {
        dispatch(productsSlice.actions.setPrice(state.prices[state.page][0]));
        dispatch(productsSlice.actions.setShowPrice(true));
      }
    }
  }, [isFetching]);

  // useEffect(() => {
  //   if (pagesInfo.page > 0 && !isFetching) {
  //     fetchData(pagesInfo.page);
  //     dispatch(productsSlice.actions.setShowPrice(false));
  //   }
  // }, [pagesInfo.page]);

  // useEffect(() => {
  //   if (pagesInfo && pagesInfo.page !== state.page) {
  //     if (!isFetching) {
  //       productsSlice.actions.setPage(pagesInfo.page);
  //       fetchData(pagesInfo.page);
  //     }
  //   }
  // }, [pagesInfo]);


const handlePagination = (val:number)=>{
  if (val!== state.page) {
         if (!isFetching) {
           productsSlice.actions.setPage(val);
           fetchData(val);
         }
        }
  if (val> 0 && !isFetching) {
               fetchData(val);
               dispatch(productsSlice.actions.setShowPrice(false));
             }
}

  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <Row>
            <Col md={12}>
              <div
                style={{
                  maxHeight: 'calc(100vh - 130px)',
                  overflow: 'hidden auto',
                }}>
                <TableActionBar
                  title={t('prices')}
                  search={search}
                  showFilter={false}
                  showDelete={selectedIds.length > 0}
                  delete={() => {
                    Confirm({
                      message: t('delete_confirmation'),
                      onConfirm: () => remove(),
                    });
                  }}
                  edit={() => {
                    formik.resetForm({ values: state.prices[state.page] });
                    setOpenEditAllTable(true);
                  }}
                  editText={t('edit')}
                  addText={t('add_price')}
                  add={
                    havePermission('Add Pricing')
                      ? () => {
                        dispatch(addPriceSlice.actions.setIsOpen(true));
                        setModal((pre) => ({ ...pre, openAddPrice: true }));
                      }
                      : undefined
                  }
                />

                {/* <DashboardTable
                 
                  header={[t('material'), t('service'), t('price'), '']}
                  body={generateData()}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={() => {}}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  sort_fields={getListSort(['voucher_no'
                  ,'date','price'
                  ,''],'Pricing')}
                  fetchSortedData={fetchSortedData}
                 
                /> */}
                <SortTable
                  header={[
                    t('material'),
                    t('glass_code'),
                    t('service'),
                    t('glasswork_code'),
                    t('price'),
                    '',
                  ]}
                  onSelect={toggleSelectedId}
                  hasMore={state.hasMore}
                  loadMore={() => { }}
                  pagesInfo={pagesInfo}
                  setPagesInfo={setPagesInfo}
                  handlePagination={handlePagination}
                  sort_fields={getListSort(
                    [
                      'glass_name',
                      'glass_code',
                      'glass_work_name',
                      'glass_work_code',
                      'price',
                      '',
                    ],
                    'Pricing',
                  )}
                  fetchSortedData={fetchSortedData}
                  state={state.prices[state.page] ?? []}>
                  <>{rows()}</>
                </SortTable>
              </div>
            </Col>
          </Row>
          <EditALlTable
            saveUpdate={upadtePrices}
            open={openEditALlTable}
            setOpen={setOpenEditAllTable}
            headers={[t('material'), t('service'), t('price'), '']}
            values={formik.values.map((ele) => ({
              material: ele.glasses.name,
              service: ele.glassworks.name,
              price: ele.price,
            }))}
            error={formik.errors}
            touched={formik.touched}
            lines_number={formik.values.length}
            handleChange={customHandleChange}
            handleBlur={formik.handleBlur}
            maxHeight={'100%'}
          />
          {/* <AddModal /> */}
          {modal.openAddPrice && (
            <AddPrice
              close={() => setModal((pre) => ({ ...pre, openAddPrice: false }))}
            />
          )}

          {modal.openEditPricing && (
            <EditPricing
              close={() =>
                setModal((pre) => ({ ...pre, openEditPricing: false }))
              }
            />
          )}

          {modal.openShowProduct && (
            <ShowProduct
              close={() =>
                setModal((pre) => ({ ...pre, openShowProduct: false }))
              }
            />
          )}

          {modal.openShowMaterial && (
            <ShowMaterial
              close={() =>
                setModal((pre) => ({ ...pre, openShowMaterial: false }))
              }
            />
          )}

          {modal.openShowService && (
            <ShowService
              close={() =>
                setModal((pre) => ({ ...pre, openShowService: false }))
              }
            />
          )}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
function alertError500(err: any) {
  throw new Error('Function not implemented.');
}
